// extracted by mini-css-extract-plugin
export default {"icon":"InfoIcon_icon__KXjkU"};